import * as XLSX from "xlsx";

/**
 * Trigger browser download of an .xlsx file with a single sheet built from
 * headers + rows.
 */
export function downloadXlsx(
    filename: string,
    headers: readonly string[],
    rows: readonly Record<string, string>[],
    sheetName = "Sheet1",
): void {
    const aoa: string[][] = [[...headers], ...rows.map((row) => headers.map((h) => row[h] ?? ""))];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(aoa), sheetName);
    const name = filename.toLowerCase().endsWith(".xlsx") ? filename : `${filename}.xlsx`;
    XLSX.writeFile(workbook, name);
}
